import firebase from "firebase";
import "firebase/firestore";
// import "firebase/messaging";

import firebaseConfig from "./firebaseConfig";
const firebaseApp = firebase.initializeApp(firebaseConfig);

export const firestore = firebaseApp.firestore();
export const storage = firebaseApp.storage().ref();
// export const messaging = firebase.messaging();
